import React from "react";

const iconOptions = [
  { key: "car", label: "Car", iconClass: "fa fa-car" },
  { key: "ute", label: "Ute", iconClass: "fa fa-truck" },
  { key: "van", label: "Van", iconClass: "fa fa-truck" },
  { key: "trailer", label: "Trailer", iconClass: "fa fa-truck" },
  { key: "truck", label: "Truck", iconClass: "fa fa-truck" },
  { key: "prime-mover", label: "Prime", iconClass: "fa fa-truck" },
  { key: "camera", label: "Camera", iconClass: "fa fa-video-camera" },
  { key: "plant-equipment", label: "Plant", iconClass: "fa fa-wrench" },
  { key: "portable", label: "Portable", iconClass: "fa fa-briefcase" },
];

const normalizeIconKey = (value) => {
  const rawValue = String(value || "").trim().toLowerCase();
  const tokens = rawValue.split(/\s+/);
  const faToken = tokens.find((token) => token.indexOf("fa-") === 0);
  const iconKey = (faToken || rawValue).replace(/^fa-/, "");

  const aliases = {
    taxi: "car",
    briefcase: "portable",
    suitcase: "portable",
    plant: "plant-equipment",
    equipment: "plant-equipment",
    excavator: "plant-equipment",
    prime: "prime-mover",
    "video-camera": "camera",
  };

  return aliases[iconKey] || iconKey;
};

const IconSelector = ({ value, onChange, disabled }) => {
  const selectedKey = normalizeIconKey(value);

  return (
    <div className="icon-selector" role="group" aria-label="Icon selector">
      {iconOptions.map((option) => (
        <button
          className={selectedKey === option.key ? "active" : ""}
          disabled={disabled}
          key={option.key}
          onClick={() => onChange(option.key)}
          title={option.label}
          type="button"
        >
          <i className={option.iconClass}></i>
          <span>{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default IconSelector;
